export const GET_COURSES__REQUEST = 'COURSE_TYPE__GET_COURSES__REQUEST'
export const GET_COURSES__SUCCESS = 'COURSE_TYPE__GET_COURSES__SUCCESS'
export const GET_COURSES__FAILURE = 'COURSE_TYPE__GET_COURSES__FAILURE'
export const GET_COURSE__REQUEST = 'COURSE_TYPE__GET_COURSE__REQUEST'
export const GET_COURSE__SUCCESS = 'COURSE_TYPE__GET_COURSE__SUCCESS'
export const GET_COURSE__FAILURE = 'COURSE_TYPE__GET_COURSE__FAILURE'
